import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { IMMEDIATE_HELP } from "../community/constants";

export default function AddImmediateHelpPage() {
  return <CommunityAddPage section={IMMEDIATE_HELP} />;
}
